module.exports = {
  message: {
    service_desc: '위 유틸리티를 사용하여 <strong>메인넷 Native COS, ERC-20, BEP-20</strong> 등 서로 다른 토큰 형식의 COS를 스왑해주세요',
    choose_token_type: '토큰 스왑 경로',
    fee_tips: '',
    token_type_erc20_to_bep2: 'ERC-20 => BEP2',
    token_type_erc20_to_native: 'ERC-20 => 메인넷 Native COS',
    token_type_bep2_to_erc20: 'BEP2 => ERC-20',
    token_type_bep2_to_native: 'BEP2 => 메인넷 Native COS',
    token_type_native_to_erc20: '메인넷 Native COS => ERC-20',
    token_type_native_to_bep2: '메인넷 Native COS => BEP2',
    token_type_bep20_to_native: 'BEP-20 => 메인넷 Native COS',
    token_type_native_to_bep20: '메인넷 Native COS => BEP-20',
    enter_address: '토큰 스왑을 위한 계정 및 주소',
    enter_exchange_memo: 'Memo (토큰 스왑 주소가 거래소로 모니터링 되므로, 원활한 거래 진행을 위해 거래소에서 제공하는 특정 Memo를 반드시 기입해주세요)',
    create_account_tips: '계정이 없으신가요? 새로 등록해주세요!',
    next_btn: '다음',
    start_over_btn: '다시 시작',
    ready_to_swap: '토큰 스왑할 준비를 해주세요',
    transfer_prefix: '{token}이(가) 이체 되었습니다 ',
    address: '계정 / 주소',
    memo: 'MEMO',
    auto_swap_desc: '정확한 계정 / 주소 기입 해주시고, 토큰 스왑 유틸리티가 토큰을 이체 받았을 때 해당 금액의 COS 토큰을 아래 지갑으로 보냅니다. <strong>위 프로세스는 약 5-30분 정도 소요됩니다<strong>.',
    auto_swap_desc_memo: '정확한 계정 / 주소 및 MEMO를 기입 해주시고, 토큰 스왑 유틸리티가 토큰을 이체 받았을 때 해당 금액의 COS 토큰을 아래 지갑으로 보냅니다. <strong>위 프로세스는 약 5-30분 정도 소요됩니다<strong>.',
    main_net_address: 'Contentos 메인넷 계정',
    bep2_address: 'BEP2 주소',
    erc20_address: 'ERC-20 주소',
    bep20_address: 'BEP-20 주소',
    main_net_token: 'COS MainNet',
    bep2_token: 'BEP2 COS',
    erc20_token: 'ERC-20 COS',
    bep20_token: 'BEP-20 COS',
    ok: '확인',
    Cancel: '취소',
    tips: '힌트',
    enter_address_tips: '정확한 주소를 기입해주세요',
    enter_exChange_memo_tips: '정확한 거래소 Memo를 기입해주세요',
    swap_address_invalid: '올바르지 않은 주소입니다',
    swap_address_not_exit: '위 계정은 존재하지 않는 계정입니다',
    swap_type_invalid: '잘못된 토큰 스왑 경로입니다',
    swap_system_error: '시스템 에러 발생, 잠시 후에 다시 시도해주세요',
    swap_unknown_error: '예기치 못한 오류 발생, 잠시 후에 다시 시도해주세요',
    swap_memo_invalid: 'Invalid Memo',
    invalid_bnb_exChange_memo_tips: 'Binance exchange memo should be a number',
    paste_warning: '거래소에 복사 및 붙여넣기 시 주소를 확인하시고 위의 주소와 동일한지 확인하시기 바랍니다.',
    fee_notice: '알림: {token} 전송 시 각 스왑에 대해 {fee} COS의 가스 수수료가 공제됩니다. {fee} COS 미만 금액에 대한 스왑 요청은 처리되지 않습니다.',
    fee_subject_to_change: '서비스 요금은 사전 고지 없이 변경될 수 있습니다.',
    view_status: '현재 전환 상태 보기',
    prev_step: '이전',
    go_back: '돌아가기',
    transfer_prefix_before: '귀하의',
    transfer_prefix_after: '을(를) 전송',
    copy_memo: 'MEMO 복사',
    copy_address: '주소 복사',
    copy_success: '복사 완료',
    memo_warning: '주의: 전송 시 반드시 올바른 MEMO를 첨부해 주세요. 시스템은 실제 입금된 수량에 따라 전환을 완료하고 귀하가 입력한 주소로 전송합니다. MEMO를 생략하지 마세요.',
    col_time: '시간',
    col_target_format: '대상 형식',
    col_target_account: '대상 계정',
    col_amount: '입금 금액',
    col_status: '상태',
    loading: '로딩 중\u2026',
    no_data: '데이터 없음',
    next_update_hint: '{time} 후 데이터 갱신',
    status_done: '완료',
    status_pending: '처리 중',
    panel_title_status: '현재 전환 상태',
    panel_title_step1: '토큰 전환 도구',
    panel_title_step2: '토큰 전환 준비 완료',
    panel_subtitle_status: '소스 토큰 형식을 선택하여 전환 기록을 확인하세요',
    source_network: '소스 토큰 형식',
    conversion_record: '전환 기록',
    new_label: '새'
  }
}
